
import Vue from "vue"
import { mapActions, mapState } from "vuex"
import ActionDialog from "@/components/ActionDialog.vue"
import eventsStub from "./events.stub"
import EventsForm from "./EventsForm.vue"

export default Vue.extend({
  name: "EventsCreateDialog",

  components: {
    EventsForm,
    ActionDialog
  },

  props: {
    shown: { type: Boolean, default: false }
  },

  data: function() {
    return {
      visible: this.shown,
      form: { ...eventsStub }
    }
  },

  computed: mapState("events", {
    eventsStateCreateIsLoading: "createIsLoading"
  }),

  watch: {
    visible(visible): void {
      this.$emit("update:shown", visible)
    },
    shown(visible): void {
      this.visible = visible
    }
  },

  methods: {
    ...mapActions("events", {
      eventsActionsCreate: "create"
    }),

    submit(): void {
      this.$refs.eventsForm.submit(async () => {
        try {
          await this.eventsActionsCreate(this.form)
          this.$success(this.$t("eventsActionsCreateSuccess", {
            eventTitle: this.form.title
          }))
          this.clear()
          this.close()
        } catch(e) {
          this.$error(e.message)
        }
      })
    },

    clear(): void {
      this.$refs.eventsForm.resetFields()
      this.form = { ...eventsStub }
    },

    close(): void {
      this.visible = false
    }
  }
})
